import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/merchant_mini_program_tasks', { params })
}
